import { ReactComponent as SaleIcon } from '../../../../../assets/icons/Navegation/dalefon.svg';
import { ReactComponent as ArrowIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle, headerTitleStyle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';

const TriangleIcon = (props) => <ArrowIcon style={triangle} {...props} />;

const CallCenterSalesMenu = ({
  userPermissions,
  openMenuSales,
  handleClickSales,
  activeStyle,
  drawerOpen,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  header,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('CALLCENTER_LEADS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='CALLCENTER_LEADS'
          to='/sales/dashboard'
          title='Mis Ventas'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('CALLCENTER_LEADS_SUPERVISOR') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='CALLCENTER_LEADS_SUPERVISOR'
          to='/sales/ejecutivo'
          title='Ventas Ejecutivos'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('CALLCENTER_LEADS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='CALLCENTER_LEADS'
          to='/sales/ejecutivo/list-transfer-sales'
          title='Ventas por transferencia'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('CALLCENTER_LEADS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='CALLCENTER_LEADS'
          to='/leads'
          title='Leads'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('CALLCENTER_LEADS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='CALLCENTER_LEADS'
          to='/paymentlinks'
          title='Mis ligas de pago'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {(userPermissions?.includes('CALLCENTER_LEADS') ||
        userPermissions?.includes('CALLCENTER_LEADS_SUPERVISOR')) && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.sales?.kind === 'header' && (
                <div style={headerTitleStyle}>{header.sales.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClickSales : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Dalefon'
            IconComponent={(props) => <SaleIcon style={icons} {...props} />}
            openMenu={openMenuSales}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuSales}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default CallCenterSalesMenu;
